__turbopack_context__.v({
  "cooperationsList": "Cooperations-shared-module-scss-module__0EMm9G__cooperationsList",
});
